<template>
  <div class="flex flex-col md:flex-row w-full h-[calc(100dvh-var(--nav-height,0px))] overflow-hidden">
    <!-- Channel list sidebar -->
    <div
      :class="[
        'flex flex-col min-h-0 md:flex-none md:w-[60%] md:max-w-[452px] md:min-w-[262px]',
        'bg-grey-background-subdued md:bg-white md:border-r-1 md:border-grey-divider-subdued md:border-solid',
        selectedChannelUrl ? 'hidden md:flex' : 'flex-1',
      ]"
    >
      <div class="flex-shrink-0">
        <slot name="channelListHeader" />
      </div>
      <div class="flex-1 min-h-0 overflow-y-auto">
        <slot name="channelList" />
      </div>
    </div>

    <!-- Message conversation view -->
    <div :class="['flex flex-col flex-1 min-h-0', selectedChannelUrl ? '' : 'hidden md:flex']">
      <!-- Conversation not found state -->
      <div v-if="showNotFound" class="flex-1 flex items-center justify-center">
        <slot name="notFound" />
      </div>

      <!-- Main conversation layout -->
      <template v-else-if="selectedChannelUrl">
        <div class="flex-shrink-0 bg-white">
          <slot name="header" />
        </div>

        <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
          <slot name="messageList" />
        </div>

        <div class="flex flex-col flex-shrink-0">
          <slot name="messageError" />
          <slot name="sendError" />
          <slot name="composer" />
        </div>
      </template>

      <!-- Empty state when no channel selected (desktop only) -->
      <div v-else class="flex-1 flex items-center justify-center ml-32">
        <slot name="empty" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'MessagesLayout',
  props: {
    selectedChannelUrl: {
      type: String,
      default: null,
    },
    showNotFound: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
